import React from 'react';
import TermsOfServicePage from '../components/TermsOfServicePage';
import PrivacyPolicyPage from '../components/PrivacyPolicyPage';

// Standalone, directly-linkable version of the same Terms/Privacy content
// shown in-app via LegalDocModal.jsx (Sidebar footer, AuthModal, sign-up
// consent checkbox) — that modal stays exactly as it is; this is an
// ADDITIONAL way to reach the identical content at its own real URL
// (/terms, /privacy — see terms.html/privacy.html + firebase.json's
// rewrites), for anyone who needs a link to send/cite/bookmark rather than
// having to open the app and find the right footer link. Both entry points
// render the exact same TermsOfServicePage/PrivacyPolicyPage components, so
// the content itself can never drift between the two.
//
// The cross-link between docs (e.g. "see our Privacy Policy") is a real
// navigation here (onOpenPrivacy/onOpenTerms just set window.location),
// unlike the modal's in-place content swap — there's no "in place" on a
// standalone page, and a real URL change is exactly what you'd want if you
// bookmarked or shared this specific page.
export default function LegalStandalonePage({ doc }) {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100">
      <header className="border-b border-slate-800/80">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 flex items-center gap-2.5">
          <a href="/" className="flex items-center gap-2.5">
            <img src="/img/quotehaul-logo 600px.webp" alt="QuoteHaul" className="h-8 w-auto object-contain" />
            <span className="text-lg font-bold text-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>QuoteHaul</span>
          </a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
        <div className="bg-slate-900 border border-slate-800 rounded-2xl p-6 sm:p-8">
          {doc === 'privacy' ? (
            <PrivacyPolicyPage onOpenTerms={() => { window.location.href = '/terms'; }} />
          ) : (
            <TermsOfServicePage onOpenPrivacy={() => { window.location.href = '/privacy'; }} />
          )}
        </div>
      </main>

      <footer className="max-w-3xl mx-auto px-4 sm:px-6 py-8 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-slate-500">
        <a href="/" className="hover:text-slate-300 hover:underline transition">Home</a>
        <a href="/terms" className="hover:text-slate-300 hover:underline transition">Terms of Service</a>
        <a href="/privacy" className="hover:text-slate-300 hover:underline transition">Privacy Policy</a>
        <span>© {new Date().getFullYear()}{' '}
          <a href="https://xayvr.com" target="_blank" rel="noopener noreferrer" className="hover:text-slate-300 hover:underline transition">XAYVR Company, LLC</a>
        </span>
      </footer>
    </div>
  );
}
